export default __webpack_public_path__ + "static/media/sponsor-icon.1842cf89.webp";